<template>
  <section>
    <div id="splash" :class="focus ? 'splash-focused' : 'splash-unfocused'">
      <h1 class="title is-3">{{ name }}</h1>
    </div>
    <div
      id="content-tab"
      :class="focus ? 'content-tab-focused' : 'content-tab-unfocused'"
    >
      <div id="tab-buttons">
        <div></div>
        <button class="content-button" @click="$emit('close-content')">
          <i class="chevron-down"></i>
        </button>
        <b-field>
          <b-switch
            size="is-small"
            :left-label="true"
            type="is-link"
            v-model="captions"
            style="float: right; margin-right: 0 !important;"
          >
            Transcript
          </b-switch>
        </b-field>
      </div>
      <div class="scroll-box">
        <component :is="site" :captions="captions" />
      </div>
    </div>
  </section>
</template>

<script>
import Hoge from "@/components/sites/0.vue";
import Hillcrest from "@/components/sites/1.vue";
import Turner from "@/components/sites/2.vue";
import Lane from "@/components/sites/3.vue";
import OShag from "@/components/sites/4.vue";
import D2 from "@/components/sites/5.vue";
import Burruss from "@/components/sites/6.vue";
import Squires from "@/components/sites/7.vue";

export default {
  name: "LocationContent",
  components: {
    Hoge,
    Hillcrest,
    Turner,
    Lane,
    OShag,
    D2,
    Burruss,
    Squires
  },
  props: {
    name: {
      type: String
    }
  },
  mounted() {
    const splash = document.getElementById("splash");
    splash.style = `background-image: linear-gradient(
        180deg,
        hsla(340, 62.4%, 32.4%, 0) 0%,
        hsla(340, 63.6%, 6.5%, 1) 100%
      ), url(${this.image});`;
  },
  computed: {
    image() {
      return require(`@/assets/stopicons/${this.selected}.jpg`);
    },
    selected() {
      return this.$store.state.selected;
    },
    language() {
      return this.$store.state.language;
    },
    focus() {
      return this.$store.state.focus;
    },
    site() {
      if (this.selected == 0) {
        return "Hoge";
      } else if (this.selected == 1) {
        return "Hillcrest";
      } else if (this.selected == 2) {
        return "Turner";
      } else if (this.selected == 3) {
        return "Lane";
      } else if (this.selected == 4) {
        return "OShag";
      } else if (this.selected == 5) {
        return "D2";
      } else if (this.selected == 6) {
        return "Burruss";
      } else if (this.selected == 7) {
        return "Squires";
      }
      return null;
    }
  },
  data() {
    return {
      captions: true
    };
  }
};
</script>

<style lang="scss" scoped>
.content-tab-focused {
  height: 85%;
}

.content-tab-unfocused {
  height: 67%;
}

.splash-focused {
  height: 15%;
}

.splash-unfocused {
  height: 33%;
}

section {
  flex-direction: column;
  height: calc(100vh - 7rem);
  padding-bottom: 0;
  overflow: flow;
}

#splash {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 1rem;
  background-position: center top;
  background-size: cover;
}

#content-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  padding: 3vh 2vw;
  background: $red-gradient;
}

#tab-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 92%;
  margin-bottom: 1rem;
}

.title {
  text-shadow: 0px 0px 4px #000;
}

.scroll-box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  scrollbar-color: $grey rgba(0, 0, 0, 0);
  padding: 0 1rem;
}

.switch {
  color: white;
}
</style>
